var _line, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.6389,
    y1: 5.47223,
    x2: 16.3611,
    y2: 5.47223,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1381_3364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2075 14.1429L5.10375 13.0699L4 14.1429L5.10375 15.2159L6.2075 14.1429ZM22.4387 15.6606C22.8531 15.6606 23.2506 15.5006 23.5436 15.2157C23.8366 14.9309 24.0012 14.5445 24.0012 14.1416C24.0012 13.7388 23.8366 13.3524 23.5436 13.0676C23.2506 12.7827 22.8531 12.6227 22.4387 12.6227V15.6606ZM11.3475 7L5.0975 13.0759L7.305 15.2219L13.555 9.14602L11.3475 7ZM5.0975 15.2159L11.3475 21.2918L13.555 19.1458L7.305 13.0699L5.0975 15.2159ZM6.20125 15.6606H22.4387V12.6227H6.2075L6.20125 15.6606Z",
    fill: "#011149"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1381_3364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.2857,
    fill: "white",
    transform: "translate(4 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e1ef5253f1b1b4021f7fd59d2dad63c7.svg";
export { ForwardRef as ReactComponent };